import { InjectionToken } from '@angular/core';

import { CollectionFilteringDataAdapter } from './collection-filtering-data-adapter.interface';

export const COLLECTION_FILTERING_DATA_ADAPTER = new InjectionToken<CollectionFilteringDataAdapter>('Collection Filtering Data Adapter');
